import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import BackButton from "../img/back-button.png"
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'
import MobileHeader from './mobileHeader'
import * as ctf from 'contentful';
import dateFormat from "dateformat";

const MobileNews = () => {
  const [projects, setProjects] = useState([]);
  const client = ctf.createClient({
    space: 'fdtw7gymput4',
    accessToken: '-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E'
  });

  useEffect(() => {

    fetchDataProject();

  }, []);



  const fetchDataProject = async () => {
    try {
      const resp = await client.getEntries({ content_type: 'news' });
      setProjects(resp.items);
    } catch (error) {
      console.log(error);
    }

  }
  return (
    <div style={{ background: "#000" }}>
      <div className="Mobile_header">
        <Link to="/" className=" mobile_back" style={{ border: 'none', marginTop: '.5rem', marginLeft: '.5rem' }} >
          <img src={BackButton} alt="" />
        </Link>
        {/* <img src={LogoMain} alt="logo" /> */}
        <Link to="/">
          <LogoDarkAnimator />
        </Link>
        <div className=""></div>
      </div>
      <div className="project-menu ">
        <ul>
          {projects != null && projects.map((item) => {
            return (
              <li className="py-2" >
                <Link to={`/news/${item?.sys?.id}`}>{item?.fields?.title}
                  <span className="text-white">
                    <br />
                    {dateFormat(item?.sys?.createdAt, "mmmm dd")}
                  </span>
                </Link>


              </li>
            )
          })}
        </ul>
      </div>

    </div>
  )
}

export default MobileNews